module.exports = __webpack_public_path__ + "ui-static/img/watermark_dark.db9ed3d5.svg";